import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Input, Button } from "antd";

import './style.css';
const InputProps = {...Input.defaultProps,...Input.propTypes}

/**
 * Input文本输入框
 */
class RmtInput extends PureComponent {
    constructor(props) {
        super(props);
        
        this.state = {
            fieldProps: {},
            suffixWidth: 0,
        };
    }

    componentDidMount(){
        const observer = new ResizeObserver((e,o)=>{
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
    }

    componentWillUnmount(){
        // 解决异常组件卸载调用setState
        this.setState = ()=>{}
    }

    static getDerivedStateFromProps(props,state) {
        // 判断props中的属性
        if (props.fieldProps&&state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(RmtInput.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state,fieldProps:{...newProps}}
        }
        return state
    }

    renderSuffixButton() {
        const { buttonProps={} } = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }

    render() {
        const { prefixLayout, suffixLayout, style={}, suffixButton, value } = this.props.fieldProps;
        const { fieldProps, suffixWidth } =this.state;
        return (
            <>
                <div className="rmt-input">
                    {
                        !!prefixLayout&&<div className="rmt-input-prefix-layout">{prefixLayout}</div>
                    }
                    <div className="rmt-input-content-layout" style={style}>
                        <span style={{color: value === "已备案" ? "#008000" : "#FF1313"}}>{value ? value : "未备案"}</span>
                    </div>
                    {
                        (!!suffixLayout&&!suffixButton)&&<div className="rmt-input-suffix-layout">{suffixLayout}</div>
                    }
                    {
                        (!!suffixButton&&!suffixLayout)&&<div className="rmt-input-suffix-layout">{this.renderSuffixButton()}</div>
                    }
                </div>
                <style>
                    {
                        `div[data-name = '${this.props.name}'] .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth>0? suffixWidth : 35}px);
                        }`
                    }
                </style>
            </>
        )
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        }else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}
export default RmtInput;

RmtInput.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

RmtInput.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
}